export function removeLastCharacterEqualTo(str, character = "/") {
  if (str.charAt(str.length - 1) === character) {
    return str.slice(0, -1);
  }
  return str;
}
